import ajax from './../ajax';

export function getAllCourses() {
  return ajax('/courses', {
    method: 'GET'
  });
}

export function getCurrentCourse(courseKey) {
  return ajax(`/show_by_course_key/${courseKey}`, {
    method: 'GET'
  });
}

export function getCourseSyllabus(name, email, phone, city, course_id) {
  return ajax(`/syllabus_requests`, {
    method: 'POST',
    body: {
      name,
      email,
      phone,
      city,
      course_id
    }
  });
}

export function buyACourse(
  courseKey,
  name,
  email,
  phone,
  dob,
  gender,
  city,
  hear_about_us,
  current_status,
  levelId,
  price
) {
  return ajax(`/courses/${courseKey}/buy`, {
    method: 'POST',
    body: {
      buy: {
        name,
        email,
        phone,
        dob,
        gender,
        city,
        hear_about_us,
        current_status,
        levelId,
        price
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/course.js